import { useId, type ReactNode } from 'react';
import { Card, CardContent } from '../ui/card/Card';

export interface FormSectionProps {
    title: string;
    /** Short guidance shown under the title, beside the fields from `lg` up. */
    description?: ReactNode;
    children: ReactNode;
}

export function FormSection({ title, description, children }: FormSectionProps) {
    const headingId = useId();

    return (
        <section aria-labelledby={headingId} className="grid gap-4 lg:grid-cols-3 lg:gap-6">
            <div className="space-y-1 lg:pt-5">
                <h2 id={headingId} className="font-semibold text-mp-foreground">
                    {title}
                </h2>
                {description && <p className="text-sm text-mp-muted">{description}</p>}
            </div>
            <Card className="min-w-0 lg:col-span-2">
                <CardContent className="py-5">{children}</CardContent>
            </Card>
        </section>
    );
}
